import './Markers.css';

export function SailboatSvgData(width: number, height: number, fillColor: string) {
  return `
    <svg class="idata-target-marker" xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 1400 1400">
   <g fill=${fillColor} style="transform: none;">
      <g>
         <path id="p1BwbCyx65" d="M273 1017 c-18 -45 -35 -90 -39 -99 -6 -17 22 -18 491 -18 293 0 495 4 493 9 -1 5 -52 50 -113 100 l-110 90 -345 1 -345 0 -32 -83z"></path>
         <path id="peetndoDA" d="M320 833 c0 -15 268 -478 277 -478 4 0 9 109 11 243 l2 242 -145 0 c-80 0 -145 -3 -145 -7z"></path>
         <path id="p182wDob7W" d="M670 520 l0 -320 35 0 c51 0 151 36 212 77 163 108 235 333 167 516 l-18 47 -198 0 -198 0 0 -320z"></path>
      </g>
   </g>
</svg>`;
}
